/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { EditorModule } from "document-model";
import { lazy } from "react";

/** Document editor module for the "powerhouse/renown-credential" document type */
export const RenownCredentialEditor: EditorModule = {
  Component: lazy(() => import("./editor.js")),
  documentTypes: ["powerhouse/renown-credential"],
  config: {
    id: "renown-credential-editor",
    name: "Renown Credential Editor",
  },
};
